function updateCartDrawerPrice() {
  window.PXUTheme.asyncView
    .load(
      window.PXUTheme.routes.cart_url, // template name
      "ajax" // view name (suffix)
    )
    .done(({ html, options }) => {
      if (options.item_count > 0) {
        const cartDetails = $(html.content).find(".ajax-cart__details-wrapper");

        $(".ajax-cart__details-wrapper").replaceWith(cartDetails);
        $(".ajax-cart__empty-cart-message").addClass("is-hidden");
        $(".ajax-cart__form").removeClass("is-hidden");
        $("[data-ajax-cart-trigger]").addClass("has-cart-count");
        $('[data-bind="itemCount"]').text(options.item_count);
      } else {
        $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
        $(".ajax-cart__form").addClass("is-hidden");
        $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
        $('[data-bind="itemCount"]').text("0");
      }
      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
}

function handleOpenOnDeliveryCheckbox(checkbox) {
  const variantId = 50187188633926;
  const headers = {
    "Content-Type": "application/json",
  };

  const container = checkbox.closest(".aqr-checkbox-container");
  container.classList.add("loading");
  checkbox.disabled = true;

  const update = checkbox.checked
    ? fetch("/cart/add.js", {
        method: "POST",
        headers,
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      }).then(() => updateCartDrawerPrice())
    : fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          const item = cart.items.find((item) => item.id === variantId);
          if (item) {
            return fetch("/cart/change.js", {
              method: "POST",
              headers,
              body: JSON.stringify({ id: item.key, quantity: 0 }),
            }).then(() => updateCartDrawerPrice());
          }
        });

  update.finally(() => {
    container.classList.remove("loading");
    checkbox.disabled = false;
  });
}
